import ResourcesModule from '../../resources/resources';
import {copyCreativeDefinition} from './creativesTextBlock';

export class CopyContentModalController {
  /* @ngInject */
  constructor(creative, variation, variations, close) {
    this.copyCreativeDefinition = copyCreativeDefinition;
    this.actions = ['duplicateFrom', 'applyTo'];
    this.action = this.actions[0];
    this.creative = creative;
    this.variation = variation;
    this.close = close;
    this.variations = variations;
    this.selectCreative(null);
    this.selectVariation();
  }

  get singleSelect() {
    return this.action.match(/From$/);
  }

  get creatives() {
    return _.chain(this.variations).map('creatives').flatten().value();
  }

  get selectedCreatives() {
    return _.filter(this.creatives, ['selected', true]);
  }

  selectVariation() {
    this.variations.forEach((variation) => {
      if (this.variation.name == variation.name) {
        this.selectedVariation = variation;
      }
    });
  }

  selectCreative(selectedCreative) {
    this.creatives.forEach((creative) => {
      creative.selected = creative == selectedCreative;
    });
  }

  applyAction() {
    this.selectedCreatives.forEach((creative) => {
      if (this.action.match(/From$/)) {
        this.copyCreativeDefinition(creative, this.creative);
      } else {
        this.copyCreativeDefinition(this.creative, creative);
      }
    });
    this.close();
  }
}

export default angular.module('app.components.campaigns.copyContentModal', [
  ResourcesModule.name
])
  .controller('CopyContentModalController', CopyContentModalController);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/copyContentModal.js
 **/